module.exports = __webpack_public_path__ + "img/5coin@2x.61bcf35b.png";